import clsx from 'clsx';
import { ProductPopover } from '~/features/product-details/components/ProductOverview/components/ProductPopover/ProductPopover';
import Checkmark from '~/icons/checkmark.svg';
import { ProductUspItem } from '~/lib/data-contract';
import { Image, RawHtml, Typography, TypographyProps } from '~/shared/components';
import styles from './ProductUSPItem.module.scss';

interface USPIconProps {
    className?: string;
    icon?: ProductUspItem['icon'];
}

export const USPIcon: React.FC<USPIconProps> = ({ className, icon }) => {
    if (!icon?.src) return <Checkmark className={clsx(styles.productUSPItemIcon, className)} />;

    return (
        <Image
            {...icon}
            className={clsx(styles.productUSPItemIcon, className)}
            alt={icon.alt ?? ''}
            width={17}
            height={17}
            sizes="17px"
            disableSkeleton
        />
    );
};

interface Props extends Omit<TypographyProps, 'children'> {
    icon?: ProductUspItem['icon'];
    label: React.ReactNode;
    tooltip?: string;
}

export const ProductUSPItem: React.FC<Props> = ({
    className,
    icon,
    label,
    tooltip,
    as = 'div',
    variant = 'paragraph-S',
    ...rest
}) => (
    <Typography
        className={clsx(styles.productUSPItem, className)}
        as={as}
        variant={variant}
        {...rest}
    >
        <USPIcon icon={icon} />

        <div className={styles.productUSPItemLabel}>{label}</div>

        {!!tooltip && (
            <ProductPopover>
                <Typography className={styles.productUSPItemTooltip} as="div" variant="paragraph-M">
                    <RawHtml html={tooltip} shouldSanitizeHtml />
                </Typography>
            </ProductPopover>
        )}
    </Typography>
);
